export default "__VITE_ASSET__Dol5W3kw__"